import { render, staticRenderFns } from "./WorkFloEventCard.vue?vue&type=template&id=38b60a96&"
import script from "./WorkFloEventCard.vue?vue&type=script&lang=js&"
export * from "./WorkFloEventCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloEventCard.vue?vue&type=style&index=0&id=38b60a96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports